export const selectTeamPageGlobalFilters = (state) => state.globalFilters.teamPage;
export const selectMeshListGlobalFilters = (state) => state.globalFilters.meshList;
